/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiClientFromJSON, ApiClientToJSON, } from './ApiClient';
export function ApiOAuthKeyFromJSON(json) {
    return ApiOAuthKeyFromJSONTyped(json, false);
}
export function ApiOAuthKeyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'apiKey': !exists(json, 'apiKey') ? undefined : json['apiKey'],
        'apiSecret': !exists(json, 'apiSecret') ? undefined : json['apiSecret'],
        'client': !exists(json, 'client') ? undefined : ApiClientFromJSON(json['client']),
        'clientId': !exists(json, 'clientId') ? undefined : json['clientId'],
        'domain': !exists(json, 'domain') ? undefined : json['domain'],
        'id': !exists(json, 'id') ? undefined : json['id'],
    };
}
export function ApiOAuthKeyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'apiKey': value.apiKey,
        'apiSecret': value.apiSecret,
        'client': ApiClientToJSON(value.client),
        'clientId': value.clientId,
        'domain': value.domain,
        'id': value.id,
    };
}
